













import {
  computed,
  defineComponent,
  getCurrentInstance
} from "@vue/composition-api";
import { sendGaEvent } from "@/helpers/ga-helper";

export default defineComponent({
  name: "OccStar",
  props: {
    id: {
      type: Number,
      default: undefined
    },
    isActive: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "standard"
    },
    gaEventCategory: {
      type: String,
      default: ""
    }
  },
  emits: ["toggleStar"],
  setup(props, { emit }) {
    const iconClass = computed(() => {
      return [
        `occ-star__icon--type_${props.type}`,
        props.isActive ? "occ-star__icon--star" : ""
      ];
    });

    const iconName = computed(() => {
      if (props.type === "sample") return "renewal/star-gray";
      return props.isActive ? "Star-Filled" : "renewal/star-empty-white";
    });

    const instance = getCurrentInstance();
    const toggleStar = () => {
      const newVal = !props.isActive;
      if (instance) {
        sendGaEvent(instance.proxy, {
          gaEventLabel: {
            id: props.id,
            value: newVal,
            label: newVal ? "チェック" : "未チェック"
          }
        });
      }
      emit("toggleStar", newVal);
    };

    return {
      iconClass,
      iconName,

      toggleStar
    };
  }
});
